export const agentMessageEventDataToMarkdown = (data: unknown, rawMode = false): string => {
  if (typeof data === 'string') {
    return rawMode ? `\`\`\`text\n${data}\n\`\`\`` : `${data}`;
  }

  return `\`\`\`json\n${JSON.stringify(data, null, 2)}\n\`\`\``;
};
